import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'features/app/store/store';
import type { InitialReportingState } from 'features/reporting/interfaces';

export const initialReportingState: InitialReportingState = {
  deafConnectRecorded: false,
  hearingConnectRecorded: false,
  twoLineVCORecorded: false,
  signMailConnectRecorded: false,
  sdpReceived: false,
  parentCallIdList: [],
  isNoLongerCallOwner: false,
  ringingForEndpointOccurred: false,
  agentDisconnectHearing: false,
  callPlaced: false,
};

const reportingSlice = createSlice({
  initialState: initialReportingState,
  name: 'reporting',
  reducers: {
    recordDeafConnect: (state) => {
      state.deafConnectRecorded = true;
    },
    recordHearingConnect: (state) => {
      state.hearingConnectRecorded = true;
    },
    recordCallPlaced: (state) => {
      state.callPlaced = true;
    },
    recordTwoLineVCOConnect: (state) => {
      state.twoLineVCORecorded = true;
    },
    recordSignMailConnect: (state) => {
      state.signMailConnectRecorded = true;
    },
    recordSdpReceived: (state) => {
      state.sdpReceived = true;
    },
    recordSignMailDisconnect: (state) => {
      state.signMailConnectRecorded = false;
    },
    resetSignMailConnectRecord: (state) => {
      state.signMailConnectRecorded = false;
    },
    resetDeafConnectRecord: (state) => {
      state.deafConnectRecorded = false;
    },
    resetHearingConnectRecord: (state) => {
      state.hearingConnectRecorded = false;
    },
    resetTwoLineVCORecord: (state) => {
      state.twoLineVCORecorded = false;
    },
    addParentCall: (state, action) => {
      state.parentCallIdList.push(action.payload);
    },
    markViNoLongerCallOwner: (state) => {
      state.isNoLongerCallOwner = true;
    },
    ringingOccurred: (state) => {
      state.ringingForEndpointOccurred = true;
    },
    resetRingingForEndpointOccurred: (state) => {
      state.ringingForEndpointOccurred = false;
    },
    agentDisconnectHearing: (state) => {
      state.agentDisconnectHearing = true;
    },
    resetAgentDisconnectHearing: (state) => {
      state.agentDisconnectHearing = false;
    },
    resetReportingState: () => initialReportingState,
  },
});

export const {
  recordDeafConnect,
  recordHearingConnect,
  resetReportingState,
  resetDeafConnectRecord,
  resetHearingConnectRecord,
  resetTwoLineVCORecord,
  recordTwoLineVCOConnect,
  resetSignMailConnectRecord,
  recordSignMailConnect,
  recordSignMailDisconnect,
  recordSdpReceived,
  addParentCall,
  markViNoLongerCallOwner,
  ringingOccurred,
  resetRingingForEndpointOccurred,
  agentDisconnectHearing,
  resetAgentDisconnectHearing,
  recordCallPlaced,
} = reportingSlice.actions;

export const deafConnectRecordedSelector = ({ reporting }: RootState) =>
  reporting.deafConnectRecorded;

export const hearingConnectRecordedSelector = ({ reporting }: RootState) =>
  reporting.hearingConnectRecorded;

export const twoLineVCORecordedSelector = ({ reporting }: RootState) =>
  reporting.twoLineVCORecorded;

export const sdpReceivedSelector = ({ reporting }: RootState) =>
  reporting.sdpReceived;

export const reportingReducer = reportingSlice.reducer;

export const isSignMailConnectRecordedSelector = ({ reporting }: RootState) =>
  reporting.signMailConnectRecorded;

export const selectIsViNoLongerCallOwner = ({ reporting }: RootState) =>
  reporting.isNoLongerCallOwner;

export const selectRingingForEndpointOccurred = ({ reporting }: RootState) =>
  reporting.ringingForEndpointOccurred;

export const selectCallWasPlaced = ({ reporting }: RootState) =>
  reporting.callPlaced;
